import React from "react";
import LayoutContentCenteredWithBackground from "../../components/Layouts/ContentCenteredWithBackgroundLayout";
import SignInForm from "./SignInForm";

export const route = "/sign-in";

function SignInContainer() {
  return (
    <LayoutContentCenteredWithBackground>
      <SignInForm />
    </LayoutContentCenteredWithBackground>
  );
}
SignInContainer.route = route;

export default SignInContainer;
